const dt = function(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz)
{
	return new Date(`${ay ?? by}-${am ?? bm}-${ad ?? bd}T${aH ?? bH}:${aM ?? bM}:${aS ?? bS ?? 0}${tz ?? ''}`);
};

export default function (...args)
{
	return {
		regex: /^(0?[1-9]|[1-2][0-9]|3[0-1])\/(0?[1-9]|1[0-2])\/(20[0-9][0-9])\s([0-1][0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9]))?$|^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(.+)$/,
		store_mask(match, ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz)
		{
			return dt(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz).toISOString();
		},
		display_mask(match, ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz)
		{
			const d = dt(ad, am, ay, aH, aM, aS, by, bm, bd, bH, bM, bS, tz);
			const dd = String(d.getDate()).padStart(2, '0');
			const mm = String(d.getMonth() + 1).padStart(2, '0');
			const yyyy = d.getFullYear();
			const h = String(d.getHours()).padStart(2, '0');
			const m = String(d.getMinutes()).padStart(2, '0');
			const s = String(d.getSeconds()).padStart(2, '0');
			return `${dd}-${mm}-${yyyy} ${h}:${m}:${s}`;
		}
	};
}

